import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=77144069&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"
import style0 from "./certificate.vue?vue&type=style&index=0&id=77144069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77144069",
  null
  
)

export default component.exports